import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Button, Text, VStack } from '@chakra-ui/react';
import { AdvisorProfileHubGate, AdvisorProfileLayout } from '@src/components/sco/Advisors/layout/AdvisorProfileLayout';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { ReviewStep } from '@src/components/sco/Advisors/sections/advisorApplication/ReviewStep';
import { aboutYouFromUser, valuesFromProfile } from '@src/components/sco/Advisors/sections/advisorApplication/useAdvisorApplication';
import { AdvisorsQueryState } from '@src/components/sco/Advisors/shared/AdvisorsQueryState';
import { UserProfile } from '@src/components/sco/Members/UserProfile';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ADVISOR_PROFILE_STATUS_APPROVED } from '@src/constants/advisor-profile-statuses';
import { MY_ADVISOR_PROFILE } from '@src/gql/queries/MyAdvisorProfile';
import { ScoAdvisorProfile } from '@src/graphql-types';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
type MyProfileData = {
  myAdvisorProfile?: ScoAdvisorProfile | null;
};
const ViewBody = () => {
  const $ = _c(17);
  const paths = useAdvisorsPaths();
  const {
    currentUser
  } = useCurrentUser();
  const t0 = !currentUser?.userId;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      skip: t0,
      fetchPolicy: "cache-and-network"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const profileQuery = useQuery(MY_ADVISOR_PROFILE, t1);
  const myProfile = profileQuery.data?.myAdvisorProfile;
  const isApproved = !!myProfile?.isApproved || myProfile?.statusKey === ADVISOR_PROFILE_STATUS_APPROVED;
  const slug = currentUser?.slug;
  if (isApproved && slug) {
    let t2;
    if ($[2] !== slug) {
      t2 = <Box height="full" minHeight="70vh" overflowY="auto" width="full"><UserProfile embedded={true} manageBreadcrumbs={false} userSlug={slug} /></Box>;
      $[2] = slug;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  const t2 = profileQuery.loading && !myProfile;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Text color="colorPalette.fg/70" fontFamily="longform" fontSize="sm">You are not in the directory yet. This is a preview of the card founders will see after approval.</Text>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== currentUser || $[6] !== myProfile) {
    t4 = myProfile ? <ReviewStep aboutYou={aboutYouFromUser(currentUser)} currentUser={currentUser} values={valuesFromProfile(myProfile)} /> : <Text color="colorPalette.fg/60">No advisor profile loaded.</Text>;
    $[5] = currentUser;
    $[6] = myProfile;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== paths.profileEdit) {
    t5 = <Button asChild={true} alignSelf="flex-start" variant="outline"><NextLink href={paths.profileEdit}>Edit profile</NextLink></Button>;
    $[8] = paths.profileEdit;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <VStack align="stretch" gap={4}>{t3}{t4}{t5}</VStack>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== profileQuery.error || $[14] !== t2 || $[15] !== t6) {
    t7 = <AdvisorsQueryState error={profileQuery.error} loading={t2}>{t6}</AdvisorsQueryState>;
    $[13] = profileQuery.error;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};

/** `/advisors/profile/view` — public card when live, preview when not listed. */
export const AdvisorProfileViewSection = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AdvisorProfileHubGate><AdvisorProfileLayout compactHeader={true} activeKey="view" description="How founders see you." title="Profile"><ViewBody /></AdvisorProfileLayout></AdvisorProfileHubGate>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};